import { render } from "./ChooseMenu.vue?vue&type=template&id=69ae7a64&scoped=true&ts=true"
import script from "./ChooseMenu.vue?vue&type=script&lang=ts"
export * from "./ChooseMenu.vue?vue&type=script&lang=ts"

import "./ChooseMenu.vue?vue&type=style&index=0&id=69ae7a64&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ae7a64"]])

export default __exports__